import React, {useEffect, useMemo, useRef, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import {toast} from "react-toastify";
import AuditLogService from "../../../services/AuditLogService";
import {Button} from "primereact/button";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import Spinner from "reactjs-simple-spinner";
import {Tooltip} from "primereact/tooltip";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";


const AuditLog = (props) => {

    const columns = useMemo(
        () => [
            {
                header: 'id',
                field: 'audit_id',
            },
            {
                header: 'Event',
                field: 'event',
            },
            {
                header: 'Audited Model',
                field: 'auditable_type',
            },
            {
                header: 'Audited Model Id',
                field: 'auditable_id'
            },
            {
                header: 'Old Values',
                field: 'old_values'
            },
            {
                header: 'New Values',
                field: 'new_values',
            },
            {
                header: 'URL',
                field: 'url'
            },
            {
                header: 'Ip Address',
                field: 'ip_address'
            },
            {
                header: 'User Agent',
                field: 'user_agent',
            },
            {
                header: 'User',
                field: 'user'
            },
            {
                header: 'Created_At',
                field: 'created_at'
            },
            {
                header: 'Updated_At',
                field: 'updated_at',
            },
        ],
        []
    )


    const [data, setData] = useState([])

    const [selectedData, setSelectedData] = useState([])
    const dt = useRef(null);

    const exportColumns = columns.map(col => ({title: col.header, dataKey: col.field}));

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({selectionOnly});
    }

    const exportPdf = () => {
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                doc.autoTable(exportColumns, data);
                doc.save('audit_log_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + '.pdf');
            })
        })
    }


    const exportExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(data);
            const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
            const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            saveAsExcelFile(excelBuffer, 'audit_log_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear());
        });
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + EXCEL_EXTENSION);
            }
        });
    }

    const onSelectionChange = (e) => {
        setSelectedData(e.value);
    }

    const [loading, setLoading] = useState(true);

// eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true)
        AuditLogService.getAllAudits()
            .then(res => {
                console.log("data: ", res);
                setData(res.data.data)
                setLoading(false)
            }).catch(err => {
            console.log('error: ', err)
            setData([])
            toast.error('Error loading data. Reload page, ' +
                'if error persist contact system administrator', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });
            setLoading(false)
        })

    }, []);



    const header = (
        <div className="flex align-items-center export-buttons">
            <Button type="button" icon="pi pi-file" onClick={() => exportCSV(false)}
                    className="mr-2 p-button-secondary p-button-sm" data-pr-tooltip="CSV"/>
            <Button type="button" icon="pi pi-file-excel" onClick={exportExcel}
                    className="p-button-dark mr-2 p-button-sm" data-pr-tooltip="XLS"/>
            <Button type="button" icon="pi pi-file-pdf" onClick={exportPdf} className="p-button-danger mr-2 p-button-sm"
                    data-pr-tooltip="PDF"/>
            <Button type="button" icon="pi pi-filter" onClick={() => exportCSV(true)}
                    className="p-button-info ml-auto p-button-sm" data-pr-tooltip="Export Selection Only"/>
        </div>
    );

    const filters = {
        'auditable_type': {
            operator: FilterOperator.OR,
            constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
        },
        'auditable_id': {
            operator: FilterOperator.OR,
            constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
        },
        'event': {
            operator: FilterOperator.OR,
            constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
        },
        'url': {
            operator: FilterOperator.OR,
            constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
        },
        'old_values': {
            operator: FilterOperator.OR,
            constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
        },
        'new_values': {
            operator: FilterOperator.OR,
            constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
        },
        'user': {
            operator: FilterOperator.OR,
            constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
        },
        'created_at': {
            operator: FilterOperator.OR,
            constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
        },

    }

    const modelBodyTemplate = (audit) => {
        return audit.auditable_type.split('\\').pop();
    };

    const userBodyTemplate = (audit) => {
        return (
            <>
                {audit.user === null ? (
                    <span>Not Audited</span>
                ) : (
                    <ul className="list-group-flush">
                        <li className="list-group-item">
                            <b>Name: </b>{JSON.parse(audit.user).name} | <b>Email: </b> {JSON.parse(audit.user).email}
                        </li>
                        <li className="list-group-item">
                            <b>Roles: </b>{JSON.parse(audit.user).roles}
                        </li>
                        <li className="list-group-item">
                            <b>Created: </b>

                            {
                                new Date(JSON.parse(audit.user).created_at).toLocaleDateString('en-US', {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric',
                                })
                            }
                            &nbsp;|&nbsp;
                            <b>Updated: </b>

                            {
                                new Date(JSON.parse(audit.user).updated_at).toLocaleDateString('en-US', {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric',
                                })
                            }
                        </li>
                    </ul>
                )}
            </>
        );
    };

    const valuesBodyTemplate = (audit) => {
        return (
            <ul className="list-group-flush">
                {
                    Object.entries(JSON.parse(audit.old_values)).map(([key, value]) => (
                        <li className="list-group-item" key={key}>
                            <strong>{key}:</strong> {value}
                        </li>

                    ))
                }
            </ul>

        )
    }
    const newValuesBodyTemplate = (audit) => {
        return (
            <ul className="list-group-flush">
                {
                    Object.entries(JSON.parse(audit.new_values)).map(([key, value]) => (
                        <li className="list-group-item" key={key}>
                            <strong>{key}:</strong> {value}
                        </li>

                    ))
                }
            </ul>

        )
    }

    const formatCreatedDate = (audit) => {
        return new Date(audit.created_at).toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        })
    }
    const formatUserAgent = (audit) => {
        return audit.user_agent.split(' ')[0]
    }
    const formatUpdatedDate = (audit) => {
        return new Date(audit.updated_at).toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        })
    }

    return (
        <div>
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                            &nbsp;|&nbsp;
                            Audit Log
                            {/*<span className="font-weight-bold text-danger">Module Under Construction</span>*/}
                        </ul>
                        {loading && (
                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                <Spinner
                                    size="medium"
                                    message="Loading Audits, Please wait....."
                                    line-fg-color="#64c3c2"
                                />
                            </div>

                        )}
                        {!loading && (
                            <div className="row mt">
                                <div className="card col-lg-12">
                                    <div className="card">
                                        <h5 className="title h3 px-4">Audit Log</h5>
                                        <Tooltip target=".export-buttons>button" position="bottom"/>
                                        <DataTable value={data} responsiveLayout="scroll" header={header}
                                                   paginator
                                                   paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                   rowsPerPageOptions={[5, 10, 25, 50]}
                                                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                                   rows={5}
                                                   size="large"
                                                   stripedRows={true}
                                                   sortMode="multiple" filters={filters} filterDisplay="menu"
                                                   resizableColumns
                                                   columnResizeMode="expand"
                                                   showGridlines={true}
                                                   ref={dt}
                                                   dataKey="audit_id"
                                                   scrollable scrollHeight="900px"
                                                   selection={selectedData} onSelectionChange={onSelectionChange}
                                                   selectionMode="checkbox"
                                        >
                                            <Column selectionMode="multiple"/>
                                            <Column field="auditable_type" header="Audited Model"
                                                    body={modelBodyTemplate} sortable filter
                                            ></Column>
                                            <Column field="event" header="Event" filter sortable
                                            ></Column>
                                            <Column field="old_values" body={valuesBodyTemplate}
                                                    header="Old Values" filter></Column>
                                            <Column field="new_values" style={{width: '150'}}
                                                    body={newValuesBodyTemplate}
                                                    filter header="New Values"></Column>
                                            <Column field="url" filter style={{minWidth: '6rem'}}
                                                    header="URL"></Column>
                                            <Column field="ip_address" style={{minWidth: '6rem'}}
                                                    header="IP Address"></Column>
                                            <Column field="user_agent" sortable style={{minWidth: '6rem'}}
                                                    header="User Agent" body={formatUserAgent}></Column>
                                            <Column field="user" body={userBodyTemplate}
                                                    filter header="User"></Column>
                                            <Column field="created_at" sortable style={{minWidth: '6rem'}}
                                                    header="Created At" body={formatCreatedDate}></Column>
                                            <Column field="updated_at" sortable style={{minWidth: '6rem'}}
                                                    body={formatUpdatedDate} header="Updated At"
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AuditLog;
